const ESCAPES = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
};
/** Escapa texto vindo do spec. O spec e gerado por IA: tratar como nao confiavel. */
export function esc(valor) {
    return String(valor ?? '').replace(/[&<>"']/g, (c) => ESCAPES[c] ?? c);
}
function urlImagem(base, img) {
    if (!img?.chaveR2)
        return null;
    return `${base.replace(/\/+$/, '')}/${img.chaveR2.replace(/^\/+/, '')}`;
}
function tagImg(base, img, classe) {
    const url = urlImagem(base, img);
    if (!url || !img)
        return '';
    const dim = [
        img.largura ? ` width="${img.largura}"` : '',
        img.altura ? ` height="${img.altura}"` : '',
    ].join('');
    return `<img class="${classe}" src="${esc(url)}" alt="${esc(img.alt)}" loading="lazy" decoding="async"${dim}>`;
}
const ESCALAS = {
    compacta: { base: '15px', h1: '2.1rem', h2: '1.5rem', pad: '3rem' },
    normal: { base: '16px', h1: '2.75rem', h2: '1.85rem', pad: '4.5rem' },
    ampla: { base: '17px', h1: '3.4rem', h2: '2.2rem', pad: '6rem' },
};
/**
 * ============================================================================
 * O CSS DO CHROME — so sai quando ha cabecalho ou rodape em colunas
 * ============================================================================
 *
 * Condicional de proposito. Os specs que ja estao gravados nao tem `cabecalho`
 * nem `rodape`; se estas regras entrassem no CSS de todo mundo, o HTML de cada
 * site publicado mudaria de bytes — e `content_hash` acharia que 100 mil sites
 * mudaram. Nao mudaram: ganharam CSS de um cabecalho que nao existe na pagina.
 *
 * Verificado: com este bloco fora, um spec antigo re-renderiza IDENTICO ao que
 * o renderizador anterior produzia.
 */
function cssChrome(ftTitulo) {
    return `
/* --- cabecalho ------------------------------------------------------------
   Sem JavaScript: o menu do celular e um <details>, que abre e fecha sozinho,
   responde ao teclado e ao leitor de tela. Um <script> aqui viraria mais um
   bloco inline para a CSP do Worker da borda ter de liberar. */
.cab{background:var(--fundo);border-bottom:1px solid color-mix(in srgb,var(--texto) 12%,transparent);z-index:20}
.cab.fixo{position:sticky;top:0}
.cab .env{display:flex;align-items:center;gap:1.25rem;min-height:4.25rem}
.cab-marca{display:flex;align-items:center;gap:.6rem;font-family:${ftTitulo};font-weight:700;font-size:1.05rem;text-decoration:none;color:inherit;margin-right:auto}
.cab-marca img{height:2.1rem;width:auto}
.cab-nav{display:flex;gap:1.5rem}
.cab-nav a{text-decoration:none;color:inherit;font-size:.94rem;font-weight:500;opacity:.85}
.cab-nav a:hover{opacity:1;text-decoration:underline;text-underline-offset:.3em}
.cab .btn{padding:.6rem 1.15rem;font-size:.9rem}
.cab-menu{display:none}
.cab-menu>summary{list-style:none;cursor:pointer;padding:.5rem;line-height:0}
.cab-menu>summary::-webkit-details-marker{display:none}
.cab-menu>summary svg{width:1.5rem;height:1.5rem;stroke:currentColor;fill:none;stroke-width:2}
.cab-menu[open]>summary svg .x{display:block}
.cab-menu[open]>summary svg .h{display:none}
.cab-menu svg .x{display:none}
.cab-gaveta{position:absolute;left:0;right:0;background:var(--fundo);border-bottom:1px solid color-mix(in srgb,var(--texto) 12%,transparent);padding:1rem 4vw 1.5rem;display:grid;gap:.25rem}
.cab-gaveta a{color:inherit;text-decoration:none;padding:.7rem 0;font-weight:500;border-bottom:1px solid color-mix(in srgb,var(--texto) 8%,transparent)}
@media(max-width:820px){.cab-nav{display:none}.cab .btn{display:none}.cab-menu{display:block}}

/* --- rodape --------------------------------------------------------------- */
.rodape-cols{display:grid;gap:2rem;grid-template-columns:1fr;padding-bottom:2rem}
@media(min-width:760px){.rodape-cols{grid-template-columns:2fr 1fr 1fr}}
.rodape h3{font-size:1rem;margin-bottom:.9rem}
.rodape ul{list-style:none;margin:0;padding:0;display:grid;gap:.5rem}
.rodape a{color:inherit;text-decoration:none}
.rodape a:hover{text-decoration:underline}
.rodape-sobre{max-width:44ch;margin:0}
.rodape-redes{display:flex;gap:1rem;margin-top:1rem;flex-wrap:wrap}
.rodape-fim{padding-top:1.5rem;border-top:1px solid color-mix(in srgb,var(--texto) 12%,transparent);display:flex;flex-wrap:wrap;gap:.5rem 1.5rem;justify-content:space-between}`;
}
/**
 * ============================================================================
 * O CSS DE CADA LEIAUTE
 * ============================================================================
 *
 * Vem DEPOIS do CSS base, entao sobrescreve pela ordem — nao por `!important`
 * nem por especificidade inflada. Cada bloco escreve so o que aquele leiaute
 * muda de verdade; o resto e o comportamento comum.
 *
 * `classico` e propositalmente vazio, e isso e a garantia de compatibilidade:
 * spec antigo cai no default `classico`, nao ganha CSS nenhum a mais e
 * re-renderiza byte a byte igual ao que ja esta publicado. Sem isso, uma
 * melhoria de template mudaria o `content_hash` de 100 mil sites e a proxima
 * republicacao reescreveria o bucket inteiro.
 */
const CSS_LEIAUTE = {
    classico: '',
    editorial: `
.cab{border-bottom:1px solid color-mix(in srgb,var(--texto) 14%,transparent)}
h1,h2,h3{letter-spacing:-.02em}
.hero{min-height:auto;background:var(--fundo);color:var(--texto);padding:5rem 0}
.hero::after{content:"";position:absolute;inset:auto 0 0;height:1px;background:color-mix(in srgb,var(--texto) 14%,transparent)}
.hero-bg{opacity:1;position:static;border-radius:.4rem;aspect-ratio:4/5;object-fit:cover}
.hero .env{display:grid;gap:3rem;grid-template-columns:1fr}
@media(min-width:900px){.hero .env{grid-template-columns:1.1fr .9fr;align-items:center}}
.hero p{font-size:1.2rem;max-width:46ch}
.btn-secundario{color:var(--texto)}
.cards{grid-template-columns:1fr;gap:0}
.card{background:none;border:0;border-top:1px solid color-mix(in srgb,var(--texto) 14%,transparent);border-radius:0;padding:2rem 0}
@media(min-width:760px){.card{display:grid;gap:.4rem 2.5rem;grid-template-columns:14rem 1fr}.card h3{grid-row:span 2;margin:0}}
.galeria{grid-template-columns:repeat(auto-fill,minmax(280px,1fr))}
.galeria img{border-radius:.3rem;aspect-ratio:3/4}
.dep{border-left:0;border-top:1px solid color-mix(in srgb,var(--texto) 14%,transparent);background:none;padding:1.75rem 0;font-size:1.1rem}
.cta{background:var(--fundo);color:var(--texto);border-top:1px solid color-mix(in srgb,var(--texto) 14%,transparent);text-align:left}
.cta .btn-primario{background:var(--destaque);color:#fff}
.cta .btns{justify-content:flex-start!important}`,
    vitrine: `
.cab{position:absolute;inset:0 0 auto;background:none;border:0;color:#fff}
.cab a,.cab .cab-marca{color:#fff}
.hero{min-height:92vh;text-align:center;justify-content:center}
.hero .env{max-width:44rem;margin-inline:auto}
.hero-bg{opacity:.55}
.hero::after{content:"";position:absolute;inset:0;background:linear-gradient(180deg,rgba(0,0,0,.45),rgba(0,0,0,.15) 40%,rgba(0,0,0,.55))}
.hero p{margin-inline:auto}
.hero .btns{justify-content:center}
section{padding:5.5rem 0}
.cards{gap:2rem}
.card{background:none;border:0;padding:0;text-align:center}
.card-img{aspect-ratio:1;object-fit:cover;border-radius:50%;width:8rem;margin:0 auto 1.25rem}
.galeria{grid-template-columns:repeat(4,1fr);gap:.5rem}
.galeria img{border-radius:0;aspect-ratio:1}
.galeria img:first-child{grid-column:span 2;grid-row:span 2}
@media(max-width:700px){.galeria{grid-template-columns:repeat(2,1fr)}}
.contato{background:color-mix(in srgb,var(--texto) 4%,transparent)}
.cta{background:linear-gradient(135deg,var(--primaria),var(--secundaria))}`,
    moderno: `
:root{--vidro:color-mix(in srgb,#ffffff 8%,transparent)}
.cab{background:color-mix(in srgb,var(--fundo) 82%,transparent);backdrop-filter:blur(12px);border-bottom:1px solid var(--vidro)}
.hero{min-height:78vh;background:radial-gradient(120% 90% at 15% 0%,var(--secundaria),transparent 55%),linear-gradient(160deg,var(--primaria),var(--fundo) 78%)}
.hero-bg{opacity:.28;mix-blend-mode:luminosity}
h1{letter-spacing:-.03em}
.btn{border-radius:999px}
.card{background:var(--vidro);border:1px solid color-mix(in srgb,#ffffff 14%,transparent);border-radius:1.25rem}
.galeria img{border-radius:1.1rem}
.dep{border-left:0;border-radius:1.25rem;background:var(--vidro);border:1px solid color-mix(in srgb,#ffffff 12%,transparent);padding:1.75rem}
.contato dl{padding:1.75rem;border-radius:1.25rem;background:var(--vidro);border:1px solid color-mix(in srgb,#ffffff 12%,transparent)}
.cta{background:linear-gradient(120deg,var(--primaria),var(--destaque));border-radius:1.5rem;margin:0 4vw 4rem}
.rodape{border-top:1px solid var(--vidro)}`,
    compacto: `
section{padding:3rem 0}
.hero{min-height:auto;padding:3.5rem 0}
h1{font-size:2.3rem}
h2{font-size:1.4rem}
.cards{gap:1rem;grid-template-columns:repeat(auto-fit,minmax(210px,1fr))}
.card{padding:1.15rem;border-radius:.6rem}
.card h3{font-size:1.05rem}
.galeria{grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:.6rem}
.galeria img{border-radius:.4rem;aspect-ratio:1}
.dep{padding:1rem 1.25rem}
.duas{gap:1.75rem}
.contato dl{gap:.35rem .9rem}
.cta{padding:3rem 0}
.rodape{padding:2rem 0}`,
};
function css(spec) {
    const p = spec.paleta;
    const t = spec.tipografia;
    const e = ESCALAS[t.escala];
    const destaque = p.destaque ?? p.primaria;
    const ftTitulo = `${JSON.stringify(t.titulo)},system-ui,sans-serif`;
    const ftCorpo = `${JSON.stringify(t.corpo)},system-ui,-apple-system,"Segoe UI",Roboto,sans-serif`;
    return `
:root{--primaria:${p.primaria};--secundaria:${p.secundaria};--fundo:${p.fundo};--texto:${p.texto};--destaque:${destaque}}
*,*::before,*::after{box-sizing:border-box}
html{font-size:${e.base};scroll-behavior:smooth}
body{margin:0;background:var(--fundo);color:var(--texto);font-family:${ftCorpo};line-height:1.6;-webkit-font-smoothing:antialiased}
img{max-width:100%;height:auto;display:block}
a{color:var(--primaria)}
h1,h2,h3{font-family:${ftTitulo};line-height:1.15;margin:0 0 .6em}
h1{font-size:${e.h1}}
h2{font-size:${e.h2}}
.env{width:min(1120px,92vw);margin-inline:auto}
section{padding:${e.pad} 0}
.hero{position:relative;min-height:62vh;display:flex;align-items:center;color:#fff;background:linear-gradient(135deg,var(--primaria),var(--secundaria))}
.hero-bg{position:absolute;inset:0;object-fit:cover;width:100%;height:100%;opacity:.35}
.hero .env{position:relative;z-index:1}
.hero p{font-size:1.15rem;max-width:52ch;opacity:.95}
.btns{display:flex;flex-wrap:wrap;gap:.75rem;margin-top:1.75rem}
.btn{display:inline-block;padding:.85rem 1.6rem;border-radius:.6rem;font-weight:600;text-decoration:none;transition:transform .15s ease}
.btn:hover{transform:translateY(-2px)}
.btn-primario{background:var(--destaque);color:#fff}
.btn-secundario{background:transparent;color:#fff;border:2px solid currentColor}
.btn-link{background:none;color:inherit;text-decoration:underline;padding-inline:0}
.duas{display:grid;gap:2.5rem;grid-template-columns:1fr}
@media(min-width:860px){.duas{grid-template-columns:1fr 1fr;align-items:center}}
.cards{display:grid;gap:1.5rem;grid-template-columns:repeat(auto-fit,minmax(260px,1fr))}
.card{padding:1.75rem;border-radius:.9rem;background:color-mix(in srgb,var(--texto) 4%,transparent);border:1px solid color-mix(in srgb,var(--texto) 10%,transparent)}
.card h3{margin-bottom:.4rem}
.preco{font-weight:700;color:var(--primaria);display:block;margin-top:.8rem}
.galeria{display:grid;gap:1rem;grid-template-columns:repeat(auto-fill,minmax(220px,1fr))}
.galeria img{border-radius:.7rem;aspect-ratio:4/3;object-fit:cover}
.dep{padding:1.5rem;border-left:3px solid var(--primaria);background:color-mix(in srgb,var(--texto) 3%,transparent)}
.dep cite{display:block;margin-top:.8rem;font-style:normal;font-weight:600}
.contato dl{display:grid;gap:.5rem 1rem;grid-template-columns:auto 1fr;margin:0}
.contato dt{font-weight:600}
.contato dd{margin:0}
.cta{background:var(--primaria);color:#fff;text-align:center}
.cta .btn-primario{background:#fff;color:var(--primaria)}
.rodape{padding:2.5rem 0;font-size:.875rem;opacity:.7;border-top:1px solid color-mix(in srgb,var(--texto) 12%,transparent)}
@media(prefers-reduced-motion:reduce){*{animation:none!important;transition:none!important}html{scroll-behavior:auto}}
${spec.cabecalho || spec.rodape ? cssChrome(ftTitulo) : ''}${CSS_LEIAUTE[spec.leiaute] ?? ''}
`.trim();
}
/**
 * ============================================================================
 * CABECALHO
 * ============================================================================
 *
 * Ausente no spec = nao emite nada, e a pagina fica como sempre foi. E o que
 * mantem os sites ja publicados identicos ate alguem escolher um template novo.
 *
 * O menu do celular e um `<details>`: abre, fecha, recebe foco e e anunciado
 * pelo leitor de tela sem uma linha de JavaScript. A alternativa com script
 * seria mais um bloco inline para a borda ter de liberar na CSP, para ganhar
 * nada.
 */
function renderCabecalho(spec, o) {
    const c = spec.cabecalho;
    if (!c)
        return '';
    const marca = c.marca || spec.negocio.nome;
    const logo = tagImg(o.baseCdn, c.logo, 'cab-logo');
    const links = c.menu
        .map((m) => `<a href="${esc(m.href)}">${esc(m.texto)}</a>`)
        .join('');
    const acao = c.acao
        ? `<a class="btn btn-${c.acao.estilo}" href="${esc(c.acao.href)}">${esc(c.acao.texto)}</a>`
        : '';
    // O <details> so aparece quando ha o que abrir dentro dele.
    const gaveta = c.menu.length
        ? `<details class="cab-menu"><summary aria-label="Abrir o menu">` +
            `<svg viewBox="0 0 24 24" aria-hidden="true">` +
            `<g class="h"><path d="M3 6h18"/><path d="M3 12h18"/><path d="M3 18h18"/></g>` +
            `<g class="x"><path d="M6 6l12 12"/><path d="M18 6L6 18"/></g></svg></summary>` +
            `<nav class="cab-gaveta">${links}${c.acao
                ? `<a class="btn btn-${c.acao.estilo}" href="${esc(c.acao.href)}" style="margin-top:.75rem;text-align:center">${esc(c.acao.texto)}</a>`
                : ''}</nav></details>`
        : '';
    return `<header class="cab${c.fixo ? ' fixo' : ''}"><div class="env">` +
        `<a class="cab-marca" href="#">${logo}<span>${esc(marca)}</span></a>` +
        (links ? `<nav class="cab-nav">${links}</nav>` : '') +
        acao +
        gaveta +
        `</div></header>`;
}
const REDES = {
    instagram: 'Instagram',
    facebook: 'Facebook',
    whatsapp: 'WhatsApp',
    youtube: 'YouTube',
    linkedin: 'LinkedIn',
    site: 'Site',
};
/**
 * ============================================================================
 * RODAPE
 * ============================================================================
 *
 * Sem `spec.rodape` cai no rodape de uma linha que sempre existiu — de novo,
 * para spec antigo render igual. Com ele, sai em colunas: sobre, menu, contato.
 *
 * Nao ha ano aqui, de proposito. `new Date()` tornaria o render nao
 * deterministico: no dia 1o de janeiro TODO site publicado mudaria de hash e o
 * proximo `publicar` reescreveria o bucket inteiro sem uma linha de conteudo
 * ter mudado.
 */
function renderRodape(spec, o) {
    const r = spec.rodape;
    const n = spec.negocio;
    if (!r) {
        return `<footer class="rodape"><div class="env">${esc(n.nome)}${n.endereco ? ` \u00b7 ${esc(n.endereco)}` : ''}${n.telefone ? ` \u00b7 ${esc(n.telefone)}` : ''}</div></footer>`;
    }
    const contato = [
        n.telefone ? `<li><a href="tel:${esc(n.telefone.replace(/\D/g, ''))}">${esc(n.telefone)}</a></li>` : '',
        n.whatsapp
            ? `<li><a href="https://wa.me/${esc(n.whatsapp.replace(/\D/g, ''))}" rel="noopener">WhatsApp</a></li>`
            : '',
        n.endereco ? `<li>${esc(n.endereco)}</li>` : '',
    ].join('');
    const redes = r.redes
        .map((x) => `<a href="${esc(x.href)}" rel="noopener">${esc(REDES[x.rede] ?? x.rede)}</a>`)
        .join('');
    const colunas = [
        `<div><h3>${esc(spec.cabecalho?.marca || n.nome)}</h3>${r.sobre ? `<p class="rodape-sobre">${esc(r.sobre)}</p>` : ''}${redes ? `<div class="rodape-redes">${redes}</div>` : ''}</div>`,
        r.menu.length
            ? `<div><h3>Navegue</h3><ul>${r.menu
                .map((m) => `<li><a href="${esc(m.href)}">${esc(m.texto)}</a></li>`)
                .join('')}</ul></div>`
            : '',
        contato ? `<div><h3>Contato</h3><ul>${contato}</ul></div>` : '',
    ].join('');
    return `<footer class="rodape"><div class="env"><div class="rodape-cols">${colunas}</div>` +
        `<div class="rodape-fim"><span>${esc(r.assinatura || `\u00a9 ${n.nome}`)}</span>` +
        `<span>Feito com Nyroh</span></div></div></footer>`;
}
function renderSecao(s, o) {
    switch (s.tipo) {
        case 'hero': {
            const fundo = urlImagem(o.baseCdn, s.imagemFundo);
            const botoes = s.botoes
                .map((b) => `<a class="btn btn-${b.estilo}" href="${esc(b.href)}">${esc(b.texto)}</a>`)
                .join('');
            return `<section class="hero">${fundo ? `<img class="hero-bg" src="${esc(fundo)}" alt="" aria-hidden="true">` : ''}<div class="env"><h1>${esc(s.titulo)}</h1>${s.subtitulo ? `<p>${esc(s.subtitulo)}</p>` : ''}${botoes ? `<div class="btns">${botoes}</div>` : ''}</div></section>`;
        }
        case 'sobre':
            return `<section id="sobre"><div class="env duas"><div><h2>${esc(s.titulo)}</h2><p>${esc(s.texto)}</p></div>${tagImg(o.baseCdn, s.imagem, 'sobre-img')}</div></section>`;
        case 'servicos':
            return `<section id="servicos"><div class="env"><h2>${esc(s.titulo)}</h2><div class="cards">${s.itens
                .map((i) => `<article class="card">${tagImg(o.baseCdn, i.imagem, 'card-img')}<h3>${esc(i.titulo)}</h3><p>${esc(i.descricao)}</p>${i.preco ? `<span class="preco">${esc(i.preco)}</span>` : ''}</article>`)
                .join('')}</div></div></section>`;
        case 'galeria':
            return `<section id="galeria"><div class="env">${s.titulo ? `<h2>${esc(s.titulo)}</h2>` : ''}<div class="galeria">${s.imagens
                .map((i) => tagImg(o.baseCdn, i, 'galeria-img'))
                .join('')}</div></div></section>`;
        case 'depoimentos':
            return `<section id="depoimentos"><div class="env"><h2>${esc(s.titulo)}</h2><div class="cards">${s.itens
                .map((d) => `<blockquote class="dep"><p>${esc(d.texto)}</p><cite>${esc(d.autor)}${d.nota !== undefined ? ` — ${'★'.repeat(Math.round(d.nota))}` : ''}</cite></blockquote>`)
                .join('')}</div></div></section>`;
        case 'contato': {
            const linhas = [];
            if (s.telefone) {
                linhas.push(`<dt>Telefone</dt><dd><a href="tel:${esc(s.telefone.replace(/\D/g, ''))}">${esc(s.telefone)}</a></dd>`);
            }
            if (s.whatsapp) {
                linhas.push(`<dt>WhatsApp</dt><dd><a href="https://wa.me/${esc(s.whatsapp.replace(/\D/g, ''))}" rel="noopener">${esc(s.whatsapp)}</a></dd>`);
            }
            if (s.email)
                linhas.push(`<dt>E-mail</dt><dd><a href="mailto:${esc(s.email)}">${esc(s.email)}</a></dd>`);
            if (s.endereco)
                linhas.push(`<dt>Endereco</dt><dd>${esc(s.endereco)}</dd>`);
            if (s.horarios.length) {
                linhas.push(`<dt>Horarios</dt><dd>${s.horarios.map((h) => esc(h)).join('<br>')}</dd>`);
            }
            return `<section id="contato" class="contato"><div class="env"><h2>${esc(s.titulo)}</h2><dl>${linhas.join('')}</dl>${s.mapaEmbedUrl
                ? `<iframe src="${esc(s.mapaEmbedUrl)}" width="100%" height="320" style="border:0;margin-top:2rem;border-radius:.7rem" loading="lazy" referrerpolicy="no-referrer-when-downgrade" title="Mapa"></iframe>`
                : ''}</div></section>`;
        }
        case 'cta':
            return `<section class="cta"><div class="env"><h2>${esc(s.titulo)}</h2>${s.subtitulo ? `<p>${esc(s.subtitulo)}</p>` : ''}<div class="btns" style="justify-content:center"><a class="btn btn-${s.botao.estilo}" href="${esc(s.botao.href)}">${esc(s.botao.texto)}</a></div></div></section>`;
        case 'htmlBruto':
            // Nao escapa: e HTML do acervo, importado de proposito. Chega aqui apenas
            // pelo caminho de migracao, e o schema marca a origem.
            return s.html;
    }
}
/**
 * Renderiza o spec inteiro. Deterministica: mesmo spec, mesmos bytes, mesmo hash.
 * Nao pode conter data/hora, aleatorio ou ordem de Object.keys.
 */
export function renderizarSite(spec, opcoes) {
    /**
     * ==========================================================================
     * DOCUMENTO COMPLETO SAI INTEIRO, SEM ENVELOPE
     * ==========================================================================
     *
     * O envelope abaixo (`<!doctype html><html><head>...<body>` mais o rodape da
     * marca) e o certo para um spec de secoes tipadas. Aplicado a uma secao
     * `htmlBruto` que JA e um documento completo, ele produz um documento dentro
     * do outro — e o efeito e cumulativo:
     *
     *   1. o editor visual publica o documento inteiro por `specDeHtmlBruto`;
     *   2. o renderizador embrulha e acrescenta o rodape;
     *   3. o editor reabre o artefato, o navegador funde as duas cabecas ao
     *      parsear, e o "salvar" seguinte embrulha DE NOVO.
     *
     * A cada ida e volta o site ganhava mais um rodape da Nyroh e mais uma copia
     * do CSS do envelope. Ninguem via erro; o site so ia ficando errado.
     *
     * Documento completo e um artefato pronto. Servir ele como esta e a unica
     * leitura honesta — e continua deterministica, que e o que o `content_hash`
     * exige.
     */
    const unica = spec.secoes.length === 1 ? spec.secoes[0] : null;
    if (unica && unica.tipo === 'htmlBruto' && ehDocumentoCompleto(unica.html)) {
        return unica.html;
    }
    const logo = urlImagem(opcoes.baseCdn, spec.negocio.logo);
    const og = urlImagem(opcoes.baseCdn, spec.seo.imagemOg) ?? logo;
    const corpo = [
        renderCabecalho(spec, opcoes),
        ...spec.secoes.map((s) => renderSecao(s, opcoes)),
    ]
        .filter(Boolean)
        .join('\n');
    return `<!doctype html>
<html lang="pt-BR">
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width,initial-scale=1">
<title>${esc(spec.seo.titulo)}</title>
<meta name="description" content="${esc(spec.seo.descricao)}">
${spec.seo.palavrasChave.length ? `<meta name="keywords" content="${esc(spec.seo.palavrasChave.join(', '))}">` : ''}
${spec.seo.indexavel ? '' : '<meta name="robots" content="noindex,nofollow">'}
${opcoes.urlCanonica ? `<link rel="canonical" href="${esc(opcoes.urlCanonica)}">` : ''}
<meta property="og:type" content="website">
<meta property="og:title" content="${esc(spec.seo.titulo)}">
<meta property="og:description" content="${esc(spec.seo.descricao)}">
${og ? `<meta property="og:image" content="${esc(og)}">` : ''}
${opcoes.urlCanonica ? `<meta property="og:url" content="${esc(opcoes.urlCanonica)}">` : ''}
${logo ? `<link rel="icon" href="${esc(logo)}">` : ''}
<style>${css(spec)}${spec.cssExtra ? `\n${spec.cssExtra}` : ''}</style>
</head>
<body>
${corpo}
${renderRodape(spec, opcoes)}
</body>
</html>`;
}
/**
 * O HTML ja e uma pagina inteira, com `<html>` proprio?
 *
 * Deliberadamente simples: procura a tag de abertura de `<html>` (com ou sem
 * doctype antes). Fragmento de secao nao tem `<html>`; documento tem. Nao vale a
 * pena um parser aqui — e esta funcao roda no Worker da borda, onde nao existe
 * DOM e cada quilobyte conta.
 */
export function ehDocumentoCompleto(html) {
    return /<html[\s>]/i.test(html.slice(0, 4096));
}
/**
 * sha256 do HTML, em hex. Web Crypto, disponivel no Node 20+, no Bun e no Worker
 * da Cloudflare — o mesmo codigo roda nos tres.
 */
export async function hashConteudo(html) {
    const bytes = new TextEncoder().encode(html);
    const digest = await crypto.subtle.digest('SHA-256', bytes);
    return Array.from(new Uint8Array(digest))
        .map((b) => b.toString(16).padStart(2, '0'))
        .join('');
}
/** Chave canonica do artefato no R2. Uma funcao so, para nao divergir entre chamadores. */
export function chaveArtefato(siteId, versaoId) {
    return `sites/${siteId}/${versaoId}.html`;
}
//# sourceMappingURL=renderizador.js.map